import React from "react";
import BiblePanel from "@/pages/admin/BiblePanel";
import LegacyHost from "@/pages/admin/os/LegacyHost";

export default function DoctrineDocsPage() {
  return (
    <LegacyHost
      title="Doctrine Docs"
      migratedFrom="Editorial desk · The Bible"
      testid="os-system-doctrine"
    >
      <BiblePanel />
    </LegacyHost>
  );
}
